import mixpanel from 'mixpanel-browser'
import getConfig from 'next/config'

import { getUser } from '@src/utils'

import { TrackEventType } from './type'

type ConfigVars = {
  enableEventTracking: boolean
  token: string
}

const getConfigVars = (): ConfigVars => {
  const { publicRuntimeConfig } = getConfig()
  return {
    enableEventTracking: publicRuntimeConfig.ENABLE_EVENT_TRACKING === 'true',
    token: publicRuntimeConfig.MIXPANNEL_PROJECT_TOKEN || '',
  }
}

const isEnable = (): boolean => {
  const { enableEventTracking, token } = getConfigVars()
  return enableEventTracking && !!token
}

const getToken = (): string => getConfigVars().token

export const useTrackEvent = () => {
  const initializeTracking = async () => {
    if (!isEnable()) {
      return
    }

    const token = getToken()
    try {
      const user = getUser()
      if (!user) {
        mixpanel.reset()
        return
      }
      mixpanel.init(token)
      mixpanel.identify(user.id)
      mixpanel.people.set({
        organizationId: user.organizationId,
      })
    } catch (error) {
      // Make sure that tracking failure doesn't affect the system
    }
  }

  const trackEvent = (
    eventName: string,
    eventType: TrackEventType,
    properties: Record<string, unknown> = {}
  ) => {
    if (!isEnable()) {
      return
    }

    try {
      mixpanel.track(eventName, {
        eventType,
        ...properties,
      })
    } catch (error) {
      // Make sure that tracking failure doesn't affect the system
    }
  }

  return { initializeTracking, trackEvent }
}
